import type { TransportSegment } from '@libs/trip-planner-interfaces';

export function flatIatas(data: TransportSegment[]): string[] {
  return data.flatMap((segment: TransportSegment) => [
    segment.arrivalIata,
    segment.departureIata,
  ]);
}
